// English-only message catalog, shaped to match Paraglide's m.*() runtime
// so call sites can switch over without changes when a second locale lands
// (brief §14 says no second locale yet).
//
// Brief §2 load-bearing decision #2: privacy is repeated in only THREE
// canonical phrasings. Don't invent a fourth — extend an existing key
// instead, or move the surface to one of the three.

// Homepage variant. The trust signal pill + tooltip together compose this
// surface's privacy promise — both belong to `privacy_homepage`.
export const privacy_homepage_pill = () => "Files never leave this tab.";
export const privacy_homepage_detail = () =>
  "Every tool runs in your browser. Open the network tab while you work and you'll see no upload requests.";

// Per-tool footer + the post-export confirmation. Same phrasing because
// they're the same beat in the flow: "you finished, nothing left."
export const privacy_task_footer = () => "Processed in your browser. Nothing was uploaded.";

// Editor variant — reserved for the /edit workspace (Phase G). Defined
// here so the key exists and the editor surface can pull from it on day one.
export const privacy_editor = () => "Editor runs in your browser. Files never leave your machine.";
